<template>
  <v-card
    :class="classes"
    elevation="0">
    <v-card-text>
      <v-img
        v-if="image.url"
        :src="image.url"
        :max-height="image.maxHeight"
        :max-width="image.maxWidth"
        class="mb-2" />
      <span v-if="title" class="text-h5">{{ title }}</span>
      <v-list v-if="items.length" :dense="dense" :class="classes">
        <v-list-item
          v-for="(item, itemIdx) in items"
          :key="`display-list-item-${itemIdx}`">
          <v-list-item-icon v-if="item.icon" :class="item.iconClass">
            <v-icon :color="item.iconColor">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import get from 'lodash/get';

export default {
  name: 'DisplayList',
  props: {
    image: {
      type: Object,
      default: () => ({}),
    },
    classes: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    moment,
    getContent(content) {
      if (!Array.isArray(content)) {
        return content;
      }

      return content.join(' ');
    },
    itemClickable(item) {
      return !!item.action || !!item.option || !!item.href || !!item.key;
    },
    handleClick(item) {
      console.log(item);
      if (item.action === 'trigger-widget-open') {
        window.openYabbrWidget();
        return false;
      }

      if (item.action) {
        this.$emit(item.action.type);
        return null;
      }

      if (item.option) {
        const opt = {
          key: item.option,
          body: {
            option: item.option,
            instanceKey: this.instanceKey,
            form: item.option,
          },
        };

        if (item.localState) {
          Object.keys(item.localState).forEach((ls) => {
            opt.body[ls] = get(this, item.localState[ls]);
          });
        }
        this.$emit('option', opt);
        return null;
      }

      if (item.key) {
        console.log(item.key);
        const opt = {
          key: item.key,
          body: {},
        };

        this.$emit('key-fire', opt);
        return null;
      }

      return null;
    },
    getHref(item) {
      if (!item.href) return false;
      return `${item.href}`;
    },
  },
  data() {
    return {
      ...this.mapState('localContext'),
    };
  },
};
</script>
